// extracted by mini-css-extract-plugin
module.exports = {"title":"Plate_title__2GAEw","subtitle":"Plate_subtitle__2R91C","iconsWrapper":"Plate_iconsWrapper__3oW-B","empty":"Plate_empty__3pRv2","divided":"Plate_divided__fXccP"};